import { render, staticRenderFns } from "./mediaPlatformNotify.vue?vue&type=template&id=600803f1&scoped=true&"
import script from "./mediaPlatformNotify.vue?vue&type=script&lang=js&"
export * from "./mediaPlatformNotify.vue?vue&type=script&lang=js&"
import style0 from "./mediaPlatformNotify.vue?vue&type=style&index=0&id=600803f1&lang=less&scoped=true&"
import style1 from "./mediaPlatformNotify.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600803f1",
  null
  
)

component.options.__file = "mediaPlatformNotify.vue"
export default component.exports